/**
 * Why a save or load failed. The store turns this into a message; the UI keeps the form and the old data in every case.
 *  storage   the browser refused to store (full or blocked)      → local repository
 *  offline   no connection, timeout, or the reply was lost       → retry
 *  session   signed out or the session expired                   → sign in again, then retry
 *  conflict  the data changed on another device since it loaded  → load the latest, then retry
 *  account   the account changed while the request was running   → result is dropped, nothing shown
 *  server    the cloud refused the data for another reason
 */
export type FailReason = "storage" | "offline" | "session" | "conflict" | "account" | "server";

export class RepoError extends Error {
  constructor(readonly reason: FailReason, message: string = reason, readonly detail?: string) {
    super(message);
    this.name = "RepoError";
  }
}

export const failReasonOf = (e: unknown): FailReason => (e instanceof RepoError ? e.reason : "storage");
